var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupportGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.3042C8.2805 1.3042 6.59929 1.81419 5.1693 2.76968C3.7393 3.72517 2.62476 5.08325 1.96661 6.67217C1.30846 8.26109 1.13625 10.0095 1.47178 11.6963C1.8073 13.3831 2.63548 14.9325 3.85159 16.1486C5.0677 17.3647 6.61711 18.1929 8.3039 18.5284C9.9907 18.8639 11.7391 18.6917 13.328 18.0336C14.9169 17.3754 16.275 16.2609 17.2305 14.8309C18.186 13.4009 18.696 11.7197 18.696 9.99985C18.696 7.69362 17.7798 5.48185 16.1491 3.8511C14.5183 2.22035 12.3066 1.3042 10.0003 1.3042Z",
    stroke: "#33A9A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1602 5.39021C9.55822 5.38026 8.96138 5.50303 8.41216 5.74979C7.86294 5.99656 7.37481 6.36126 6.98247 6.81799C6.92796 6.8685 6.88414 6.92944 6.8536 6.99719C6.82306 7.06494 6.80643 7.13813 6.80469 7.21243C6.80465 7.28098 6.8184 7.34883 6.84512 7.41195C6.87185 7.47507 6.91099 7.53218 6.96023 7.57986C7.00947 7.62755 7.0678 7.66484 7.13175 7.68952C7.1957 7.71421 7.26396 7.72578 7.33247 7.72354C7.47923 7.7199 7.61957 7.66258 7.72691 7.56243C8.02383 7.21447 8.39262 6.93498 8.80788 6.74317C9.22315 6.55136 9.67504 6.45179 10.1325 6.45132C11.4436 6.45132 12.2602 7.29576 12.2602 8.34576V8.37354C12.2602 9.60132 11.2825 10.2847 9.73802 10.4013C9.67548 10.4037 9.61416 10.4193 9.55807 10.4471C9.50197 10.4748 9.45237 10.5141 9.41251 10.5624C9.37265 10.6106 9.34344 10.6667 9.32677 10.7271C9.3101 10.7874 9.30636 10.8506 9.3158 10.9124V12.0554C9.32962 12.1929 9.39419 12.3204 9.49692 12.4128C9.59965 12.5053 9.73315 12.5561 9.87135 12.5554H9.93246C10.07 12.5416 10.1974 12.477 10.2899 12.3743C10.3823 12.2716 10.4332 12.1381 10.4325 11.9999V11.2402C12.0991 11.0069 13.4491 10.1291 13.4491 8.30687V8.2791C13.4325 6.61243 12.1325 5.39021 10.1602 5.39021Z",
    fill: "#33A9A0",
    stroke: "#33A9A0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87804 15.2502C10.2616 15.2502 10.5725 14.9393 10.5725 14.5558C10.5725 14.1722 10.2616 13.8613 9.87804 13.8613C9.49451 13.8613 9.18359 14.1722 9.18359 14.5558C9.18359 14.9393 9.49451 15.2502 9.87804 15.2502Z",
    fill: "#33A9A0",
    stroke: "#33A9A0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportGreen);
export default __webpack_public_path__ + "static/media/support-green.41aa836faf2a1ec1992d8d2008af6a97.svg";
export { ForwardRef as ReactComponent };